/**
 * O que a tela do fechamento regulatório (`OB-06`, ADR-067) usa e o teste confere, fora do
 * componente: a recarga a quente do Vite só funciona em arquivo que exporta só componente.
 */
import type { FraudeNoFechamento } from "../api/tipos";
import type { Significado } from "../componentes/tinta";

/** Como cada situação da foto aparece na ficha. */
export const SITUACAO_DA_FOTO: Record<
  FraudeNoFechamento["foto"],
  { texto: string; cor: Significado }
> = {
  PRONTA: { texto: "foto anonimizada", cor: "verde" },
  PENDENTE: { texto: "na fila da anonimização", cor: "azul" },
  SEM_COPIA: { texto: "sem foto", cor: "amarelo" },
};

/** O endereço do pacote. Link, e não fetch: o navegador baixa em fluxo, com o cookie de
 *  leitura — como a exportação da fila. */
export function enderecoDoPacote(concessao: string, periodo: string): string {
  return `/tollvision/fechamentos/pacote?${new URLSearchParams({
    concessao_id: concessao,
    periodo,
  })}`;
}
